// Music playlist manifest. Tracks are served from /cve/songs/ (Vite
// publicDir) — not bundled, so the initial JS chunk stays small and
// players only fetch a track when it plays.
//
// Display names are hand-shortened from the source filenames; if a new
// track is added, just append it here with a sensible label.

export interface Track {
  /** URL-encoded filename — joined with BASE_URL + 'songs/' at play time. */
  file: string;
  /** Short label shown in the music widget. */
  label: string;
}

export const PLAYLIST: readonly Track[] = [
  { file: 'Appetite Machine (Post-Punk Cover).mp3', label: 'Appetite Machine · Post-Punk' },
  { file: 'Balada de los Bandidos.mp3', label: 'Balada de los Bandidos' },
  { file: 'British Jungle with more Amen.mp3', label: 'British Jungle' },
  { file: 'Casino Jazz (Variation).mp3', label: 'Casino Jazz' },
  { file: 'Getting Out (70s Version).mp3', label: 'Getting Out · 70s' },
  { file: 'Goth Rock variation 5.mp3', label: 'Goth Rock v5' },
  { file: 'Industrial Rock Remix (Full).mp3', label: 'Industrial Rock' },
  { file: 'Kick It con Coquette (Chorus Only Vocals, High Female).mp3', label: 'Kick It con Coquette' },
  { file: 'Reggae Cover of Dark ambient raindrop cover of 32-bit Astral Observatory.mp3', label: 'Reggae · Astral Observatory' },
  { file: 'Session from Cyber Crystal Zone (Industrial Rock Mix).mp3', label: 'Cyber Crystal · Industrial' },
  { file: 'Session from Cyber Crystal Zone (Lo-Fi Mix).mp3', label: 'Cyber Crystal · Lo-Fi' },
  { file: 'Synthpop Remix (0.55).mp3', label: 'Synthpop Remix' },
  { file: 'Unbroken (J-Rock Version).mp3', label: 'Unbroken · J-Rock' },
  { file: 'Untitled (1).mp3', label: 'Untitled 1' },
  { file: 'Untitled.mp3', label: 'Untitled' },
] as const;

export function trackUrl(idx: number): string {
  const safe = Math.max(0, Math.min(PLAYLIST.length - 1, idx));
  const file = PLAYLIST[safe].file;
  return `${import.meta.env.BASE_URL}songs/${encodeURIComponent(file)}`;
}

export function trackLabel(idx: number): string {
  const safe = Math.max(0, Math.min(PLAYLIST.length - 1, idx));
  return PLAYLIST[safe].label;
}
